import { HealthGoalTypesType } from 'components/molecules/HealthGoalSelection/HealthGoalSelection';
import { getPreviewImageByGender, isRecommendedProgram } from 'store/programOverview';
import { CoachExpertDtoType } from 'types/services/magnolia/dtos/CoachExpertDto';
import { GenderKeyType } from '../../types/GenderKey';
import { initialState, ProgramPreviewStateType, ProgramSlugsType, RootStateType } from './programPreview';

export const getState = (state: RootStateType): ProgramPreviewStateType => state.programPreview || initialState;

export const getHasProgramChanged = (state: RootStateType): boolean => {
	return getState(state).hasProgramChanged;
};

export const getIsProgramPreviewLoaded = (state: RootStateType): boolean => {
	return getState(state).loaded;
};

export const getTitle = (state: RootStateType): string | void => {
	return getState(state).title;
};

export const getSeoTitle = (state: RootStateType): string | void => {
	return getState(state).seoTitle;
};

export const getDescription = (state: RootStateType): string | void => {
	return (getState(state) as any).description;
};

export const getInfo = (state: RootStateType): string | void => {
	return (getState(state) as any).info;
};

export const getPreview = (state: RootStateType): string | void => {
	return (getState(state) as any).preview;
};

export const getTools = (state: RootStateType): any[] | void => {
	return getState(state).tools;
};

export const getError = (state: RootStateType): Error | null => {
	return getState(state).error;
};

export const getIntensity = (state: RootStateType): number => {
	return getState(state).intensity;
};
export const getHasDynamicRecipes = (state: RootStateType): boolean => {
	return getState(state).dynamicRecipes;
};
export const getHasDynamicWorkouts = (state: RootStateType): boolean => {
	return getState(state).dynamicWorkouts;
};

export const getGoal = (state: RootStateType): string | void => {
	return getState(state).goal;
};

export const getContainedInformation = (state: RootStateType): Object | void => {
	return getState(state).contains;
};

export const getDuration = (state: RootStateType): Object | void => {
	return getState(state).contains?.days;
};

export const getSlugURL = (state: RootStateType): string | void => {
	return state.programPreview.slug;
};

export const getExternalId = (state: RootStateType): string | void => {
	return getState(state).externalId;
};

export const getPreviewItems = (state: RootStateType): any[] | void => {
	return getState(state).previewItems;
};

export const getPreviewImage = (state: RootStateType, gender: GenderKeyType | null): Object | void => {
	return getPreviewImageByGender(getState(state), gender);
};

export const getIsInactive = (state: RootStateType): boolean => {
	return !!getState(state).inactive;
};

export const getStartProgramFailed = (state: RootStateType): boolean => {
	return getState(state).startProgramFailed;
};

export const getIsLoadingProgram = (state: RootStateType): boolean => {
	return getState(state).isLoadingProgram;
};

export const getIsNewProgram = (state: RootStateType): boolean => {
	return getState(state).isNewProgram;
};

export const getMetaDescription = (state: RootStateType): string | null => {
	return getState(state).metaDescription || null;
};

export const getSlugs = (state: RootStateType): ProgramSlugsType | void => {
	return getState(state).slugs;
};

export const getExperts = (state: RootStateType): CoachExpertDtoType[] => {
	return getState(state).experts;
};

export const getHideExpertLogo = (state: RootStateType): boolean => Boolean(getState(state).hideExpertLogo);

export const getIsRecommended = (
	state: RootStateType,
	intensity: number | null,
	healthGoal: HealthGoalTypesType | null
): boolean => {
	return isRecommendedProgram(state.programPreview, intensity, healthGoal);
};
